import {
  type AmplifyError,
  updatePassword,
} from '@backoffice-frontend/authentication'
import {
  Body1,
  ExpanderTile,
  MoiaCard,
  MoiaCardContent,
  MoiaCardHeader,
} from '@backoffice-frontend/patterns'
import { Restricted } from '@backoffice-frontend/restricted'
import { useLoggedInUserEmail } from '@backoffice-frontend/user-management-ui'
import { BoumRight as Rights } from '@moia-dev/moia-token-claims'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IdTokenTile } from '../IdTokenTile'
import { ChangePasswordForm } from './ChangePasswordForm'
import { AccountDivider, AccountLayout } from './components/AccountLayout'
import { MFASuccessfulEnabledView } from './components/MFASwitch/MFASuccessfulEnabledView'

export const CredentialsView = () => {
  const { t } = useTranslation()
  const [changeSuccess, setChangeSuccess] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const email = useLoggedInUserEmail()

  const handleSubmitPassword = async ({
    newPassword,
    oldPassword,
  }: {
    newPassword: string
    oldPassword: string
  }) => {
    try {
      await updatePassword({ oldPassword, newPassword })
      setChangeSuccess(true)
    } catch (_error) {
      const error = _error as AmplifyError
      if (error.name === 'InvalidPasswordException') {
        setErrorMessage(t('common_passwordPolicy_error'))
      } else {
        setErrorMessage(t('authenticatedAppView_oldPasswordIncorrect'))
      }
    }
  }

  return (
    <>
      <AccountLayout
        header={t('authenticatedAppView_credentials_header')}
        subheader={t('authenticatedAppView_credentials_caption')}
      >
        <MoiaCard>
          <MoiaCardHeader title={t('common_email_label')} />

          <MoiaCardContent>
            <Body1
              css={theme => ({
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
              })}
            >
              {email}
            </Body1>
            <MFASuccessfulEnabledView />
            <ExpanderTile
              heading={t('authenticatedAppView_managePassword_header')}
              loading={false}
            >
              <ChangePasswordForm
                onSubmit={handleSubmitPassword}
                changeSuccess={changeSuccess}
                errorMessage={errorMessage}
              />
            </ExpanderTile>
            <Restricted requiredRights={[Rights.DEV_USE_FEATURE_TOGGLES]}>
              <IdTokenTile />
            </Restricted>
          </MoiaCardContent>
        </MoiaCard>
      </AccountLayout>
      <AccountDivider />
    </>
  )
}
